import { createSlice } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  systemAnnouncementList: [],
  cancelSystemAnnouncementList: [],
  // cancelScheduleSystemAnnouncementList: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "SystemAnnouncement",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get list
    builder.addCase(Act.getSystemAnnouncementList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.getSystemAnnouncementList.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        systemAnnouncementList: payload.data || [],
        totalCount: payload.totalcount || 0,
      }),
    );
    builder.addCase(Act.getSystemAnnouncementList.rejected, (state, action) => ({
      ...state,
      loading: false,
      systemAnnouncementList: [],
      totalCount: 0,
    }));

    // Add
    builder.addCase(Act.addSystemAnnouncementApi.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.addSystemAnnouncementApi.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        systemAnnouncementList: payload?.data
          ? [payload.data, ...state.systemAnnouncementList]
          : state.systemAnnouncementList,
        totalCount: payload?.data ? state.totalCount + 1 : state.totalCount,
      }),
    );
    builder.addCase(Act.addSystemAnnouncementApi.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    // Cancel
    builder.addCase(Act.cancelSystemAnnouncementApi.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.cancelSystemAnnouncementApi.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      cancelSystemAnnouncementList: payload?.data ? [payload.data, ...state.cancelSystemAnnouncementList] : state.cancelSystemAnnouncementList,
      totalCount: payload?.data ? state.totalCount + 1 : state.totalCount,
    }),
    );
    builder.addCase(Act.cancelSystemAnnouncementApi.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    // Cancel Scheduled Time
    // builder.addCase(Act.cancelScheduledSystemAnnouncementApi.pending, (state, action) => ({
    //   ...state,
    //   loading: true,
    // }));
    // builder.addCase(Act.cancelScheduledSystemAnnouncementApi.fulfilled, (state, { payload }) => ({
    //   ...state,
    //   loading: false,
    //   cancelScheduleSystemAnnouncementList: payload?.data ? [payload.data, ...state.cancelScheduleSystemAnnouncementList] : state.cancelScheduleSystemAnnouncementList,
    //   totalCount: payload?.data ? state.totalCount + 1 : state.totalCount,
    // }),
    // );
    // builder.addCase(Act.cancelScheduledSystemAnnouncementApi.rejected, (state, action) => ({
    //   ...state,
    //   loading: false,
    // }));
  },
});

export default slice;
